import request from '@/utils/request'

/**
 * 获取应用列表数据
 */
export const getAppLists = (data) => {
    return request({
        url: '/open/app/lists',
        params: data
    })
}
/**
 * app管理-详情
 */
export const getAppDetail = (id) => {
    return request({
        url: `/open/app/${id}`
    })
}
/**
 * 新增app
 */
export const addApp = (data) => {
    return request({
        url: '/open/app/manage',
        method: 'POST',
        data
    })
}
/**
 * 编辑app
 */
export const putApp = (data) => {
    return request({
        url: '/open/app/manage',
        method: 'PUT',
        data
    })
}

/**
 * app分组-删除
 */
export const delApp = (id) => {
    return request({
        url: `/open/app/${id}`,
        method: 'DELETE'
    })
}
// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/open/app/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}
